import { CAMERAS } from '../constants';
import { useStore } from '../Context';
import Navigation from '../components/Navigation/Navigation';
import React, { useEffect } from 'react';
import GESTURES from '../constants/gestures';
import ImageTheme from '../components/Images/ImageThemed';
import loanlogs from '../services/loanlogs';


const gestures = GESTURES.map(gesture => gesture.chances);

/**
 * 
 * @param {Integer} min 
 * @param {Integer} max 
 * @returns Integer between min and max
 */

function random() {
    const randomNum = Math.random() * 100;
    let totalPercentage = 0;
  
    for (let i = 0; i < gestures.length; i++) {
      totalPercentage += gestures[i];
      if (randomNum < totalPercentage) {
        return i;
      }
    }
  }

function SelfieSignature() {
    const { photoUri, clearPhoto, setCamera, stepForward } = useStore();

    function handleSubmit () {
        if (!photoUri.neutralSelfie) return;
        photoUri.randomSelfie = random();
        stepForward();
    };

    function handleRetakePhoto () {
        clearPhoto({ [CAMERAS.SELFIE_NEUTRAL]: null });
        setCamera({ open: true, type: CAMERAS.SELFIE_NEUTRAL });
    };

    function handleOpenCamera () {
        setCamera({ open: true, type: CAMERAS.SELFIE_NEUTRAL });
    }

    useEffect(() => {
        loanlogs.success('/selfie/neutral').catch(console.log)
    }, []);

    return (
        <main className='page-step page-sefie-neutral'>
            <Navigation />
            <header className='page-header'>
                <h1>Firma electrónica</h1>
                <p>
                    Mediante una selfie con prueba de vida estas 
                    realizando la firma del <strong>contrato del préstamo</strong>
                </p>
            </header>
            <div className='page-content frame' onClick={handleOpenCamera}>
                {photoUri.neutralSelfie 
                    ? (<img className='frame-image' src={photoUri.neutralSelfie} alt="" />) 
                    : (
                        <>
                            <ImageTheme src="/selfie-normal.svg" alt="" width="250" />
                            <p className='text-center text-balance mx-1'>
                                <strong>Presiona acá</strong> para tomar una foto <strong>sin gestos</strong>
                            </p>
                        </>
                    )
                }
            </div>
            <div className="page-actions flex-column">
                <button className='button-primary' onClick={handleSubmit}>
                    Confirmar
                </button>
                <button className='button-secondary' onClick={handleRetakePhoto}>
                    Tomar otra fotografía
                </button>
            </div>
        </main>
    );
}

export default SelfieSignature;
